module.exports = __webpack_public_path__ + "static/media/nextStepsIcon.cfa1a81a.png";